import { axios } from '@/utils/axios';

const RESOURCE_NAME  = '/accounting/cost_items';

export default {
    create(payload) {
        return axios.post(`${RESOURCE_NAME}/`, payload)
    },
    update(payload) {
        return axios.post(`${RESOURCE_NAME}/update`, payload)
    },
    remove(payload) {
        return axios.post(`${RESOURCE_NAME}/remove`, { "delete_id": payload })
    },
    select_groups() {
        return axios.get(`${RESOURCE_NAME}/select-groups`)
    },
    select(payload) {
        return axios.get(`${RESOURCE_NAME}/select-elements`, {params: payload})
    },
};